import { Dialog, MobileDialogContent } from '@/components/ui/dialog';
import { SharedAuthForm } from '@/components/auth/SharedAuthForm';
import { cn } from '@/lib/utils';

interface PublicAuthDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAuthSuccess: () => void;
  jobTitle?: string;
}

export const PublicAuthDialog = ({
  open,
  onOpenChange,
  onAuthSuccess,
  jobTitle
}: PublicAuthDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <MobileDialogContent className={cn(
        "p-6 sm:p-8 md:max-w-[520px] md:h-auto"
      )}>
        <a 
          href={window.location.origin} 
          className="block hover:opacity-80 transition-opacity mb-4 sm:mb-5"
          aria-label="Go to home page"
        >
          <img 
            src="/lovable-uploads/41653ae6-6c86-4657-96f9-4685be3c3e81.png" 
            alt="Evee AI Logo" 
            className="w-8 h-8 object-contain rounded-lg"
          />
        </a>
        
        <div className="md:flex md:items-center md:justify-center md:flex-1 md:-mt-[8vh]">
          <SharedAuthForm
            onSuccess={onAuthSuccess}
            compact={true}
            redirectAfterAuth={false}
          />
        </div>
      </MobileDialogContent>
    </Dialog>
  );
};